import { Link } from "react-router-dom";
import { OrderResponse, OrderTemplate } from "../../models/PatientModels";
import { OrderContainer, OrderFooter, OrderItem, OrderTitle } from "../Orders/OrderCard";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Checkbox } from "antd";

const OrderSetMedicationCard = ({
    medication,
    handleFunction,
    isAdminView = false,
    isSelected = true,
}: {
    medication: OrderTemplate;
    handleFunction: () => void;
    isAdminView: boolean;
    isSelected: boolean;
}) => {
    return (
        <OrderContainer
            title={
                <OrderTitle>
                    <div className="text-wrap d-inline-block me-3">
                        <span>{medication.drugName}</span>
                    </div>

                    {
                        isAdminView ?
                        <DeleteOutlined rev={undefined} className="delete-button" onClick={handleFunction}/>
                        :
                        <Checkbox checked={isSelected} onChange={handleFunction}/>
                    }
                    
                </OrderTitle>
            }
        >
            <OrderItem label="Drug Format" value={medication.drugFormat} />
            <OrderItem label="Quantity" value={medication.quantity} />
            <OrderItem label="Dosage Direction" value={medication.directions} />
        </OrderContainer>
    );
};

export default OrderSetMedicationCard;